<template>
    <div class="iframe-box">
        <el-tabs class="chart_tabs" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="数据统计看板" name="1"></el-tab-pane>
            <el-tab-pane label="数据分析看板" name="2"></el-tab-pane>
        </el-tabs>
        <!-- <div class="zhegai"></div> -->
        <iframe v-show="activeName == '1'" id="iframe1" :style="'height:' + resizeHeight" v-if="iframeSrc1.length >= 0" :src="iframeSrc1" frameborder="0"></iframe>
        <iframe v-show="activeName == '2'" id="iframe2" :style="'height:' + resizeHeight" v-if="iframeSrc2.length >= 0" :src="iframeSrc2" frameborder="0"></iframe>
    </div>
</template>
<script>
export default {
    data() {
        return {
            iframeSrc1: '',
            iframeSrc2: '',
            resizeHeight: '653',
            activeName: '1'
        };
    },
    mounted() {
        this.getDashboard1();
        this.getDashboard2();
        this.resizeHeight = window.innerHeight - 10 - 20 - 25 + 'px';
        window.onresize = () => {
            this.resizeHeight = window.innerHeight - 10 - 20 - 25 + 'px';
        };
    },
    methods: {
        handleClick() {},
        getDashboard2() {
            this.instance.get('/ubi/api/case/dashboard/dualCameraOperate', { params: {} }).then((res) => {
                if (res.code == 200) {
                    let newLink = data.data;
                    newLink = newLink.replace(/bordered=true/g, 'bordered=false');
                    this.iframeSrc2 = newLink.replace(/titled=true/g, 'titled=false');
                }
            });
        },
        getDashboard1() {
            this.instance.get('/ubi/api/case/dashboard/dualCameraDashboard', { params: {} }).then((res) => {
                if (res.code == 200) {
                    let newLink = data.data;
                    newLink = newLink.replace(/bordered=true/g, 'bordered=false');
                    this.iframeSrc1 = newLink.replace(/titled=true/g, 'titled=false');
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.iframe-box {
    width: 100%;
    height: 100% !important;
    overflow: hidden;
    position: relative;
    background: #fff;
    .chart_tabs {
        padding: 0 10px;
    }
}

#iframe1,
#iframe2 {
    width: 100%;
    height: 780px;
    padding-bottom: 78px;
}
.height_653 {
    height: 653px;
}
.zhegai {
    height: 20px;
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
}
</style>